var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7f8090",
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 96 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M680 696q-17 0-28.5-11.5T640 656V496q0-17 11.5-28.5T680 456h120q17 0 28.5 11.5T840 496v40h-60v-20h-80v120h80v-20h60v40q0 17-11.5 28.5T800 696H680Zm-300 0V456h160q17 0 28.5 11.5T580 496v40q0 17-11.5 28.5T540 576q17 0 28.5 11.5T580 616v40q0 17-11.5 28.5T540 696H380Zm60-150h80v-30h-80v30Zm0 90h80v-30h-80v30Zm-320 60V496q0-17 11.5-28.5T160 456h120q17 0 28.5 11.5T320 496v200h-60v-60h-80v60h-60Zm60-120h80v-60h-80v60Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordChart);
export default __webpack_public_path__ + "static/media/word_chart.c903f31c.svg";
export { ForwardRef as ReactComponent };